module.exports = __webpack_public_path__ + "fonts/Linearicons-Free.65060723.woff";